<template>
	<div class="card-box" :style="cardStyle">
		<div class="card">
			<img class="card-img"
				:src="info.$$opts && info.$$opts.holdCount ? info.$$opts.columnBrightImage : info.$$opts && info.$$opts.columnImage"
				alt="" @click="clickCard" />
			<div class="num-box" :style="countStyle" v-if="info.$$opts && info.$$opts.holdCount">
				{{ info.$$opts.holdCount || 0 }}
			</div>
		</div>
	</div>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
var rem = require('@/utils/rem')
export default {

	name: "card",

	props: {
		info: {
			type: Object,
		},
		index: {
			type: Number
		}
	},

	inject: ['$$activityId', '$$activityStatus', '$$activityType', 'getEnterSource'],

	computed: {
		enterSource() {
			return this.getEnterSource();
		},
		$activityStatus() {
			return this.$$activityStatus()
		},
	},

	data() {
		return {
			cardStyle: {},   // 卡片样式

			countStyle: {},  // 卡片数样式
		}
	},

	mounted() {
		this.init()
	},

	methods: {

		init() { // 初始化操作 卡片样式 是否明暗 卡片拥有数量
			this.initCardStyle()
			this.initCountStyle()
			this.reset
		},
		reset(px) {
			let fontSize = document.documentElement.style.fontSize.replace("px", "")
			let w = window.screen.width, scale = 1
			if (w >= 320 && w < 375) {
				scale = 1.2
			} else if (w <= 375) {
				scale = 1
			} else if (w > 375 && w <= 390) {
				scale = 0.97
			} else if (w > 390 && w <= 414) {
				scale = 0.91
			}
			return `${px / fontSize / scale}rem`;
		},

		handleCss(options = {}) {
			let str = `.a${JSON.stringify(options).replace(/\"/g, '')}`
			let cssStyle = rem.prototype.generateRem(str).toString()
			cssStyle = cssStyle.substr(0, cssStyle.length - 1)
			cssStyle = cssStyle.slice(7)
			return cssStyle.replace(/\,/g, ';')
		},

		initCardStyle() { // 初始化卡片样式
			let options = {}
			let card = this.info.baseConfig.card

			if (card && card.position1 && card.position1.type) {
				options[`${card.position1.type}`] = `${card.position1.value || 0}px`
			}

			if (card && card.position2 && card.position2.type) {
				options[`${card.position2.type}`] = `${card.position2.value || 0}px`
			}

			if (card && card.width) {
				options.width = `${card.width}px`
			}

			if (card && card.height) {
				options.height = `${card.height}px`
			}

			this.cardStyle = this.handleCss(options)
		},

		initCountStyle() { // 初始化卡片数样式

			let options = {}

			let count = this.info.baseConfig.holdCount

			if (count && count.position1 && count.position1.type) {
				options[`${count.position1.type}`] = `${count.position1.value || 0}px`
			}

			if (count && count.position2 && count.position2.type) {
				options[`${count.position2.type}`] = `${count.position2.value || 0}px`
			}

			options.width = `${count.width}px`
			options.height = `${count.height}px`
			options.lineHeight = `${count.height}px`

			options.color = count.color
			options.fontSize = `${count.fontSize}px`
			options.textStroke = count.stroke ? `1px ${count.stroke}` : ''
			options.fontWeight = count.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
			options.fontStyle = count.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''

			if (count && count.img && count.img.url) {
				let background = {
					backgroundImage: `url(${count.img.url})`,
					backgroundSize: `100% 100%`,
					backgroundPosition: '0px 0px',
				}
				options = Object.assign(options, background)
			}

			this.countStyle = this.handleCss(options)
		},

		clickCard() {
			this.$log.senLog({
				pointID: '12010015',
				eventType: 2,
				businessData: {
					activityType: this.$$activityType || '',
					activityId: this.$$activityId || '',
					cardId: this.info.$$opts.cardId || '',
					appSource: isMiniApplets() ? isMiniApplets() : '',
					enterSource: this.enterSource || '',
				}
			})
			let status = this.$activityStatus
			if (status != 3) {
				return
			}
			if (this.info && this.info.$$opts && this.info.$$opts.holdCount) {
				this.$emit('emitEvent', {
					type: 'viewCard',
					data: {
						index: this.index
					},
					options: null
				})
			} else {
				let txt = '待点亮后就可欣赏大图啦~'
				this.toast(txt)
			}
		},

		toast(txt, duration) { // 封装统一的信息处理函数
			this.$toast({
				styles: {
					maskColor: "rgba(0,0,0,0)",
					background: "rgba(0,0,0,0.4)",
					messageColor: "#fff"
				},
				content: txt,
				duration: duration || 2000
			})
		},
	}
};
</script>

<style scoped lang="scss">
.card-box {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	position: absolute;

	.card {
		position: relative;
		box-sizing: border-box;
		margin: 0;
		padding: 0;

		.card-img {
			width: 100%;
		}

		.num-box {
			margin: 0;
			padding: 0;
			box-sizing: border-box;
			text-align: center;
			position: absolute;
		}
	}
}
</style>
